import { calculateArrowHeads } from './arrowCalculations';
import { FLOWMAP_CONFIG } from './constants';

export const LAYER_IDS = {
    FLOWMAP: 'flowmap-layer',
    ARROWS: 'flow-arrows',
    FLOWMAP_EXTRA_CLICKAREA: 'flowmap-clickable-layer',
    FLOWMAP_EXTRA_HOVERAREA: 'flowmap-hover-layer',
    ARROWS_CLICKABLE: 'arrows-clickable-layer',
};

export const SOURCE_IDS = {
    FLOWMAP: 'flowmap',
    ARROWS: 'flowmap-arrows',
};

// NOT USED?
// left for reference

// export const LAYER_STYLES = {
//     FLOWMAP: {
//         id: LAYER_IDS.FLOWMAP,
//         type: 'line',
//         source: SOURCE_IDS.FLOWMAP,
//         paint: {
//             'line-color': ['get', 'lineColor'],
//             'line-width': [
//                 'interpolate',
//                 ['linear'],
//                 ['get', 'volume'],
//                 1,
//                 FLOWMAP_CONFIG.LINE_WIDTH.MIN,
//                 5000,
//                 FLOWMAP_CONFIG.LINE_WIDTH.MAX,
//             ],
//         },
//         layout: {
//             visibility: 'visible',
//             'line-cap': 'round',
//             'line-join': 'round',
//         },
//     },
//     ARROWS: {
//         id: LAYER_IDS.ARROWS,
//         type: 'line',
//         source: SOURCE_IDS.ARROWS,
//         paint: {
//             'line-color': ['get', 'lineColor'],
//             'line-width': [
//                 'interpolate',
//                 ['linear'],
//                 ['get', 'volume'],
//                 1,
//                 FLOWMAP_CONFIG.ARROW_WIDTH.MIN,
//                 5000,
//                 FLOWMAP_CONFIG.ARROW_WIDTH.MAX,
//             ],
//         },
//         layout: {
//             visibility: 'visible',
//             'line-cap': 'round',
//             'line-join': 'round',
//         },
//     },
//     FLOWMAP_EXTRA_CLICKAREA: {
//         id: LAYER_IDS.FLOWMAP_EXTRA_CLICKAREA,
//         type: 'line',
//         source: SOURCE_IDS.FLOWMAP,
//         paint: {
//             'line-color': 'rgba(0,0,0,0)',
//             'line-width': [
//                 'interpolate',
//                 ['linear'],
//                 ['get', 'volume'],
//                 1,
//                 FLOWMAP_CONFIG.LINE_WIDTH.MIN + 8,
//                 5000,
//                 FLOWMAP_CONFIG.LINE_WIDTH.MAX + 12,
//             ],
//         },
//         layout: {
//             visibility: 'visible',
//             'line-cap': 'round',
//             'line-join': 'round',
//         },
//     },
//     ARROWS_CLICKABLE: {
//         id: LAYER_IDS.ARROWS_CLICKABLE,
//         type: 'line',
//         source: SOURCE_IDS.ARROWS,
//         paint: {
//             'line-color': 'rgba(0,0,0,0)',
//             'line-width': [
//                 'interpolate',
//                 ['linear'],
//                 ['get', 'volume'],
//                 1,
//                 FLOWMAP_CONFIG.ARROW_WIDTH.MIN + 8,
//                 5000,
//                 FLOWMAP_CONFIG.ARROW_WIDTH.MAX + 12,
//             ],
//         },
//         layout: {
//             visibility: 'visible',
//             'line-cap': 'round',
//             'line-join': 'round',
//         },
//     },
// };

export const createDynamicLayerStyles = (normalizedMin, normalizedMax) => {
    return {
        FLOWMAP: {
            id: LAYER_IDS.FLOWMAP,
            type: 'line',
            source: SOURCE_IDS.FLOWMAP,
            paint: {
                'line-color': ['get', 'lineColor'],
                'line-width': [
                    'interpolate',
                    ['linear'],
                    ['get', 'volume'],
                    normalizedMin,
                    FLOWMAP_CONFIG.LINE_WIDTH.MIN,
                    normalizedMax,
                    FLOWMAP_CONFIG.LINE_WIDTH.MAX,
                ],
            },
            layout: {
                visibility: 'visible',
                'line-cap': 'round',
                'line-join': 'round',
            },
        },
        ARROWS: {
            id: LAYER_IDS.ARROWS,
            type: 'line',
            source: SOURCE_IDS.ARROWS,
            paint: {
                'line-color': ['get', 'lineColor'],
                'line-width': [
                    'interpolate',
                    ['linear'],
                    ['get', 'volume'],
                    normalizedMin,
                    FLOWMAP_CONFIG.ARROW_WIDTH.MIN,
                    normalizedMax,
                    FLOWMAP_CONFIG.ARROW_WIDTH.MAX,
                ],
            },
            layout: {
                visibility: 'visible',
                'line-cap': 'round',
                'line-join': 'round',
            },
        },
        FLOWMAP_EXTRA_CLICKAREA: {
            id: LAYER_IDS.FLOWMAP_EXTRA_CLICKAREA,
            type: 'line',
            source: SOURCE_IDS.FLOWMAP,
            paint: {
                'line-color': 'rgba(0,0,0,0)',
                'line-width': [
                    'interpolate',
                    ['linear'],
                    ['get', 'volume'],
                    normalizedMin,
                    FLOWMAP_CONFIG.LINE_WIDTH.MIN + 16,
                    normalizedMax,
                    FLOWMAP_CONFIG.LINE_WIDTH.MAX + 24,
                ],
            },
            layout: {
                visibility: 'visible',
                'line-cap': 'round',
                'line-join': 'round',
            },
        },
        FLOWMAP_EXTRA_HOVERAREA: {
            id: LAYER_IDS.FLOWMAP_EXTRA_HOVERAREA,
            type: 'line',
            source: SOURCE_IDS.FLOWMAP,
            paint: {
                'line-color': 'rgba(0,0,0,0)',
                'line-width': [
                    'interpolate',
                    ['linear'],
                    ['get', 'volume'],
                    normalizedMin,
                    FLOWMAP_CONFIG.LINE_WIDTH.MIN + 8,
                    normalizedMax,
                    FLOWMAP_CONFIG.LINE_WIDTH.MAX + 12,
                ],
            },
            layout: {
                visibility: 'visible',
                'line-cap': 'round',
                'line-join': 'round',
            },
        },
        ARROWS_CLICKABLE: {
            id: LAYER_IDS.ARROWS_CLICKABLE,
            type: 'line',
            source: SOURCE_IDS.ARROWS,
            paint: {
                'line-color': 'rgba(0,0,0,0)',
                'line-width': [
                    'interpolate',
                    ['linear'],
                    ['get', 'volume'],
                    normalizedMin,
                    FLOWMAP_CONFIG.ARROW_WIDTH.MIN + 8,
                    normalizedMax,
                    FLOWMAP_CONFIG.ARROW_WIDTH.MAX + 12,
                ],
            },
            layout: {
                visibility: 'visible',
                'line-cap': 'round',
                'line-join': 'round',
            },
        },
    };
};

export const normalizeFlowmapValues = (data) => {
    if (!data || data.length === 0)
        return {
            normalizeValue: () => 1,
            maxValue: 1,
            minValue: 0,
            normalizedMin: 1,
            normalizedMax: 1,
        };

    const values = data.map((item) => item.value).filter((v) => v > 0);
    if (values.length === 0)
        return {
            normalizeValue: () => 1,
            maxValue: 1,
            minValue: 0,
            normalizedMin: 1,
            normalizedMax: 1,
        };

    const maxValue = Math.max(...values);
    const minValue = Math.max(
        Math.min(...values),
        FLOWMAP_CONFIG.SCALING.MIN_THRESHOLD
    );

    // Fast pre-calculated approach
    const sortedValues = [...values].sort((a, b) => a - b);
    const percentileIndex = Math.floor(
        (sortedValues.length * FLOWMAP_CONFIG.SCALING.OUTLIER_PERCENTILE) / 100
    );
    const cappedMax =
        sortedValues[Math.min(percentileIndex, sortedValues.length - 1)];

    // Pre-calculate log values once
    const logMin = Math.log(minValue);
    const logCap = Math.log(cappedMax);
    const logRange = logCap - logMin || 1;
    const compressionFactor = FLOWMAP_CONFIG.SCALING.COMPRESSION_FACTOR;
    const baseScale =
        FLOWMAP_CONFIG.VOLUME_SCALE_FACTOR * (1 - compressionFactor);
    const outlierScale = FLOWMAP_CONFIG.VOLUME_SCALE_FACTOR * compressionFactor;
    const outlierRange = maxValue - cappedMax || 1;

    // Fast normalization function with minimal calculations
    const normalizeValue = (value) => {
        if (value <= minValue) return FLOWMAP_CONFIG.BASE_VOLUME_OFFSET;

        if (value <= cappedMax) {
            // Fast log scaling - pre-calculated constants
            const logValue = Math.log(value);
            return (
                FLOWMAP_CONFIG.BASE_VOLUME_OFFSET +
                ((logValue - logMin) / logRange) * baseScale
            );
        } else {
            // Fast outlier compression - simplified calculation
            const outlierPosition = (value - cappedMax) / outlierRange;
            const compressed = outlierPosition * outlierPosition; // Square for compression
            return (
                FLOWMAP_CONFIG.BASE_VOLUME_OFFSET +
                baseScale +
                compressed * outlierScale
            );
        }
    };

    const normalizedMin = FLOWMAP_CONFIG.BASE_VOLUME_OFFSET;
    const normalizedMax =
        FLOWMAP_CONFIG.BASE_VOLUME_OFFSET + FLOWMAP_CONFIG.VOLUME_SCALE_FACTOR;

    return { normalizeValue, maxValue, minValue, normalizedMin, normalizedMax };
};

const toWebMercator = (lng, lat) => {
    const x = (lng * 20037508.34) / 180;
    let y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
    y = (y * 20037508.34) / 180;
    return [x, y];
};

const fromWebMercator = (x, y) => {
    const lng = (x * 180) / 20037508.34;
    let lat = (y * 180) / 20037508.34;
    lat =
        (180 / Math.PI) *
        (2 * Math.atan(Math.exp((lat * Math.PI) / 180)) - Math.PI / 2);
    return [lng, lat];
};

const createCurvedLineCoordinates = (
    startLng,
    startLat,
    endLng,
    endLat,
    curvature = 0.2
) => {
    const [startX, startY] = toWebMercator(startLng, startLat);
    const [endX, endY] = toWebMercator(endLng, endLat);

    const deltaX = endX - startX;
    const deltaY = endY - startY;

    const midX = (startX + endX) / 2;
    const midY = (startY + endY) / 2;

    const offsetX = -deltaY * curvature * 0.5;
    const offsetY = deltaX * curvature * 0.5;

    const controlX = midX + offsetX;
    const controlY = midY + offsetY;

    const coordinates = [];
    const steps = 20;

    for (let i = 0; i <= steps; i++) {
        const t = i / steps;
        const invT = 1 - t;

        const x = invT * invT * startX + 2 * invT * t * controlX + t * t * endX;
        const y = invT * invT * startY + 2 * invT * t * controlY + t * t * endY;

        const [lng, lat] = fromWebMercator(x, y);
        coordinates.push([lng, lat]);
    }

    return coordinates;
};

function fixOverlappingLines(data, jitter = 3) {
    const INITIAL_CURVATURE = 0.2;
    const seen = {};

    return data.map((item) => {
        const key = `${item.startLat},${item.startLong}-${item.endLat},${item.endLong}`;

        const existingItems = seen?.[key];
        if (!!existingItems && existingItems.length > 0) {
            const updatedItem = {
                ...item,
                curvature:
                    INITIAL_CURVATURE +
                    (INITIAL_CURVATURE / 2) * existingItems.length,
            };

            seen[key].push(updatedItem);

            return updatedItem;
        } else {
            const itemWithCurvature = {
                ...item,
                curvature: INITIAL_CURVATURE,
            };

            seen[key] = [itemWithCurvature];
            return itemWithCurvature;
        }
    });
}

export const createFlowFeatures = (data, normalizeValue) => {
    return data.map((item, i) => ({
        type: 'Feature',
        properties: {
            volume: normalizeValue(item.value),
            lineColor: item.lineColor || '#ff919f',
            // Include original data for popup display
            originalValue: item.value,
            startCountry: item.startCountryIso,
            endCountry: item.endCountryIso,
            dataType: item.dataType,
            dataSource: item.dataSource,
            unit: item.unit,
            hsCode: item.hsCode,
            hsProductName: item.hsProductName,
            startLong: item.startLong,
            startLat: item.startLat,
            endLong: item.endLong,
            endLat: item.endLat,
            year: item.year,
            description: item.description,
        },
        geometry: {
            type: 'LineString',
            coordinates: createCurvedLineCoordinates(
                item.startLong,
                item.startLat,
                item.endLong,
                item.endLat,
                item.curvature
            ),
        },
    }));
};

export const createArrowFeatures = (data, normalizeValue, zoom) => {
    const arrowFeatures = [];

    data.forEach((item) => {
        const volume = normalizeValue(item.value);
        const endArrowGeometries = calculateArrowHeads(
            item.startLong,
            item.startLat,
            item.endLong,
            item.endLat,
            volume,
            zoom
        );

        if (endArrowGeometries && endArrowGeometries.length > 0) {
            endArrowGeometries.forEach((geometry) => {
                arrowFeatures.push({
                    type: 'Feature',
                    properties: {
                        volume,
                        lineColor: item.lineColor || '#ff919f',
                        // Include original data for popup display
                        originalValue: item.value,
                        startCountry: item.startCountryIso,
                        endCountry: item.endCountryIso,
                        dataType: item.dataType,
                        dataSource: item.dataSource,
                        unit: item.unit,
                        hsCode: item.hsCode,
                        hsProductName: item.hsProductName,
                        startLong: item.startLong,
                        startLat: item.startLat,
                        endLong: item.endLong,
                        endLat: item.endLat,
                        year: item.year,
                        description: item.description,
                    },
                    geometry: geometry,
                });
            });
        }
    });

    return arrowFeatures;
};

export const removeFlowmapLayers = (map) => {
    if (!map) return;

    Object.values(LAYER_IDS).forEach((layerId) => {
        if (map.getLayer(layerId)) {
            map.removeLayer(layerId);
        }
    });

    Object.values(SOURCE_IDS).forEach((sourceId) => {
        if (map.getSource(sourceId)) {
            map.removeSource(sourceId);
        }
    });
};

export const addFlowmapSources = (map, flowFeatures, arrowFeatures) => {
    if (!map) return false;

    try {
        if (!map.getSource(SOURCE_IDS.FLOWMAP)) {
            map.addSource(SOURCE_IDS.FLOWMAP, {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: flowFeatures,
                },
            });
        }

        if (!map.getSource(SOURCE_IDS.ARROWS)) {
            map.addSource(SOURCE_IDS.ARROWS, {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: arrowFeatures,
                },
            });
        }

        return true;
    } catch (error) {
        console.error('Error adding flowmap sources:', error);
        return false;
    }
};

export const addFlowmapLayers = (map, normalizedMin, normalizedMax) => {
    if (!map) return false;

    try {
        const dynamicStyles = createDynamicLayerStyles(
            normalizedMin,
            normalizedMax
        );

        if (!map.getLayer(LAYER_IDS.FLOWMAP)) {
            map.addLayer(dynamicStyles.FLOWMAP);
        }

        if (!map.getLayer(LAYER_IDS.ARROWS)) {
            map.addLayer(dynamicStyles.ARROWS);
        }

        // Add invisible clickable layers for better interaction
        if (!map.getLayer(LAYER_IDS.FLOWMAP_EXTRA_CLICKAREA)) {
            map.addLayer(dynamicStyles.FLOWMAP_EXTRA_CLICKAREA);
        }

        if (!map.getLayer(LAYER_IDS.FLOWMAP_EXTRA_HOVERAREA)) {
            map.addLayer(dynamicStyles.FLOWMAP_EXTRA_HOVERAREA);
        }

        if (!map.getLayer(LAYER_IDS.ARROWS_CLICKABLE)) {
            map.addLayer(dynamicStyles.ARROWS_CLICKABLE);
        }

        return true;
    } catch (error) {
        console.error('Error adding flowmap layers:', error);
        return false;
    }
};

export const updateFlowmapSources = (map, flowFeatures, arrowFeatures) => {
    if (!map) return false;

    try {
        const flowmapSource = map.getSource(SOURCE_IDS.FLOWMAP);
        const arrowsSource = map.getSource(SOURCE_IDS.ARROWS);

        if (flowmapSource) {
            flowmapSource.setData({
                type: 'FeatureCollection',
                features: flowFeatures,
            });
        }

        if (arrowsSource) {
            arrowsSource.setData({
                type: 'FeatureCollection',
                features: arrowFeatures,
            });
        }

        return true;
    } catch (error) {
        console.error('Error updating flowmap sources:', error);
        return false;
    }
};

export const createFlowmapLayers = async (map, data, zoom) => {
    if (!map || !data || data.length === 0) return false;

    const { normalizeValue, normalizedMin, normalizedMax } =
        normalizeFlowmapValues(data);

    const correctedData = fixOverlappingLines(data);
    const flowFeatures = createFlowFeatures(correctedData, normalizeValue);
    const arrowFeatures = createArrowFeatures(
        correctedData,
        normalizeValue,
        zoom
    );

    removeFlowmapLayers(map);

    const sourcesAdded = addFlowmapSources(map, flowFeatures, arrowFeatures);
    if (!sourcesAdded) return false;

    return addFlowmapLayers(map, normalizedMin, normalizedMax);
};

export const calculateFlowmapBounds = (data) => {
    if (!data || data.length === 0) return null;

    let minLng = Infinity;
    let maxLng = -Infinity;
    let minLat = Infinity;
    let maxLat = -Infinity;

    data.forEach((item) => {
        const { startLong, startLat, endLong, endLat } = item;

        if (
            typeof startLong !== 'number' ||
            typeof startLat !== 'number' ||
            typeof endLong !== 'number' ||
            typeof endLat !== 'number'
        ) {
            return;
        }

        minLng = Math.min(minLng, startLong, endLong);
        maxLng = Math.max(maxLng, startLong, endLong);
        minLat = Math.min(minLat, startLat, endLat);
        maxLat = Math.max(maxLat, startLat, endLat);
    });

    if (
        !isFinite(minLng) ||
        !isFinite(maxLng) ||
        !isFinite(minLat) ||
        !isFinite(maxLat)
    ) {
        return null;
    }

    // Prevent zooming in too tightly when data points are close together
    const buffer = 0.1;
    if (maxLng - minLng < buffer) {
        const center = (minLng + maxLng) / 2;
        minLng = center - buffer / 2;
        maxLng = center + buffer / 2;
    }
    if (maxLat - minLat < buffer) {
        const center = (minLat + maxLat) / 2;
        minLat = center - buffer / 2;
        maxLat = center + buffer / 2;
    }

    return [minLng, minLat, maxLng, maxLat];
};

let lastScalingParams = null;

const scalingParamsChanged = (newMin, newMax) => {
    if (!lastScalingParams) return true;
    return lastScalingParams.min !== newMin || lastScalingParams.max !== newMax;
};

let isUpdating = false;

export const updateFlowmapData = (map, data, zoom) => {
    if (isUpdating) {
        console.warn('updateFlowmapData already in progress, skipping');
        return false;
    }

    if (!map) {
        return false;
    }

    if (!data) {
        return false;
    }

    if (!map.loaded) {
        return false;
    }

    if (!map.isStyleLoaded) {
        return false;
    }

    try {
        const mapLoaded = map.loaded();
        const styleLoaded = map.isStyleLoaded();

        if (!styleLoaded) {
            return true;
        }

        if (!mapLoaded) {
            // Continue since style is loaded and we can update sources
        }
    } catch (error) {
        console.error('Error checking map state:', error);
        return false;
    }

    isUpdating = true;

    try {
        if (data.length === 0) {
            const result = updateFlowmapSources(map, [], []);
            isUpdating = false;
            return result;
        }

        const { normalizeValue, normalizedMin, normalizedMax } =
            normalizeFlowmapValues(data);

        const correctedData = fixOverlappingLines(data);
        const flowFeatures = createFlowFeatures(correctedData, normalizeValue);
        const arrowFeatures = createArrowFeatures(
            correctedData,
            normalizeValue,
            zoom
        );

        const hasExistingSources =
            map.getSource(SOURCE_IDS.FLOWMAP) &&
            map.getSource(SOURCE_IDS.ARROWS);

        if (hasExistingSources) {
            const needsLayerRecreation = scalingParamsChanged(
                normalizedMin,
                normalizedMax
            );

            if (needsLayerRecreation) {
                removeFlowmapLayers(map);
                const sourcesAdded = addFlowmapSources(
                    map,
                    flowFeatures,
                    arrowFeatures
                );
                if (!sourcesAdded) {
                    console.error(
                        'Failed to add flowmap sources during recreation'
                    );
                    isUpdating = false;
                    return false;
                }
                const result = addFlowmapLayers(
                    map,
                    normalizedMin,
                    normalizedMax
                );

                lastScalingParams = { min: normalizedMin, max: normalizedMax };
                isUpdating = false;
                return result;
            } else {
                const result = updateFlowmapSources(
                    map,
                    flowFeatures,
                    arrowFeatures
                );
                if (!result) {
                    console.error('Failed to update flowmap sources');
                }
                isUpdating = false;
                return result;
            }
        } else {
            if (map.isStyleLoaded()) {
                const result = createFlowmapLayers(map, data, zoom);
                lastScalingParams = { min: normalizedMin, max: normalizedMax };
                isUpdating = false;
                return result;
            } else {
                console.warn('Map style not ready for creating flowmap layers');
                isUpdating = false;
                return false;
            }
        }
    } catch (error) {
        console.error('Error in updateFlowmapData:', error);
        isUpdating = false;
        return false;
    }
};
